import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import Select from "react-select"
import { connect } from "react-redux"
import {
  getEventCodes,
  getSelectedEvent,
  resetSelectedEvent,
} from "store/actions"
import { getFormattedTime } from "utils"
import { LOCAL_STORAGE_TAGS } from "constants/index"

const Events = ({
  userId,
  eventTeaser,
  getSelectedEvent,
  resetSelectedEvent,
  selectedEvent,
  getEventCodes,
  eventCodes,
}) => {
  const vendors = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.CLIENTS_TAG)
  )
  const [selectedEventValue, setSelectedEventValue] = useState()

  useEffect(() => {
    return () => {
      resetSelectedEvent()
    }
  }, [])

  useEffect(() => {
    if (eventTeaser?.length > 0) {
      setSelectedEventValue({
        value: eventTeaser[0]?.id,
        label: eventTeaser[0]?.name,
      })
    }
  }, [eventTeaser])

  useEffect(() => {
    if (selectedEventValue) {
      getSelectedEvent(selectedEventValue?.value)
      getEventCodes({ eventId: selectedEventValue?.value })
    }
  }, [selectedEventValue])

  return (
    <React.Fragment>
      <h5 className="font-size-14 mb-0">
        <i className="mdi mdi-arrow-right text-primary"></i> Experiences
      </h5>
      <Row className="my-3">
        <Col>
          <Select
            options={eventTeaser?.map(event => ({
              value: event?.id,
              label: event?.name,
            }))}
            value={selectedEventValue}
            onChange={v => setSelectedEventValue(v)}
            selectProps="aria-label"
            isSearchable={false}
          />
        </Col>
      </Row>
      <Row>
        <Col className="ms-2 my-2">
          <h6>EXPERIENCE STATS</h6>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Experience has livestream</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {selectedEvent?.is_live ? "Yes" : "No"}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Experience Created</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {getFormattedTime(selectedEvent?.created_at * 1000)}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Last Edit</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {getFormattedTime(selectedEvent?.updated_at * 1000)}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Album Photos</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {selectedEvent?.media_stats?.image}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Album Videos</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {selectedEvent?.media_stats?.video}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Backgrounds</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {selectedEvent?.media_stats?.bgs}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>User role</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {parseInt(selectedEvent?.user_id) === parseInt(userId)
            ? "Host"
            : "Guest"}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Experience ID</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {selectedEvent?.id}
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col xs="6" style={{ textAlign: "center" }}>
          <label>Company</label>
        </Col>
        <Col xs="6" style={{ textAlign: "center" }}>
          {vendors?.filter(v => v?.id === selectedEvent?.vendor_id)[0]?.name ||
            ""}
        </Col>
      </Row>
      {eventCodes?.codes?.length > 0 && (
        <>
          <Row>
            <Col className="ms-2 my-2">
              <h6>CODE STATUS</h6>
            </Col>
          </Row>
          <Row className="d-flex justify-content-between">
            <Col xs="6" style={{ textAlign: "center" }}>
              <label>Code Type</label>
            </Col>
            <Col xs="6" style={{ textAlign: "center" }}>
              {eventCodes?.codes[0]?.is_digital == 1 ? "Digital" : "Physical"}
            </Col>
          </Row>
          <Row className="d-flex justify-content-between">
            <Col xs="6" style={{ textAlign: "center" }}>
              <label>Total host codes</label>
            </Col>
            <Col xs="6" style={{ textAlign: "center" }}>
              {eventCodes?.stats?.total_host}
            </Col>
          </Row>
          <Row className="d-flex justify-content-between">
            <Col xs="6" style={{ textAlign: "center" }}>
              <label>Total guest codes</label>
            </Col>
            <Col xs="6" style={{ textAlign: "center" }}>
              {eventCodes?.stats?.total_guest}
            </Col>
          </Row>
          <Row className="d-flex justify-content-between">
            <Col xs="6" style={{ textAlign: "center" }}>
              <label>Guest codes redeemed</label>
            </Col>
            <Col xs="6" style={{ textAlign: "center" }}>
              {eventCodes?.stats?.total_guest_redeemed}
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  eventTeaser: state.Profile.eventTeaser,
  selectedEvent: state.experiences.selectedEvent,
  eventCodes: state.experiences.eventCodes,
})

const mapDispatchToProps = dispatch => ({
  getSelectedEvent: values => dispatch(getSelectedEvent(values)),
  resetSelectedEvent: () => dispatch(resetSelectedEvent()),
  getEventCodes: values => dispatch(getEventCodes(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Events)
